/* lua.js generated code 0.3.0 */

CommonEffectConfig = table()
CommonEffectConfig.offsets_star = table(
    [0, table(
        [0, table(
            [0, -212.7],
            157.4,
            0.99,
            124.95,
            0
        )],
        [0, table(
            [0, -204.05],
            160.75,
            0.99,
            140.25,
            0
        )],
        [0, table(
            [0, -195.2],
            163.6,
            0.99,
            155.55,
            0
        )],
        [0, table(
            [0, -186.2],
            165.95,
            0.99,
            173.4,
            0
        )],
        [0, table(
            [0, -177.1],
            167.7,
            0.99,
            188.7,
            0
        )],
        [0, table(
            [0, -167.9],
            169,
            0.99,
            206.55,
            0
        )],
        [0, table(
            [0, -158.65],
            169.7,
            0.99,
            221.85,
            0
        )],
        [0, table(
            [0, -149.35],
            169.85,
            0.99,
            239.7,
            0
        )],
        [0, table(
            [0, -140.1],
            169.45,
            0.99,
            255,
            0
        )],
        [0, table(
            [0, -123.45],
            167.3,
            0.99,
            234.6,
            0
        )],
        [0, table(
            [0, -107.15],
            163.3,
            0.99,
            214.2,
            0
        )],
        [0, table(
            [0, -91.4],
            157.55,
            0.99,
            191.25,
            0
        )],
        [0, table(
            [0, -76.65],
            149.65,
            0.99,
            170.85,
            0
        )],
        [0, table(
            [0, -63.15],
            139.6,
            0.99,
            150.45,
            0
        )],
        [0, table(
            [0, -51.3],
            127.75,
            0.99,
            130.05,
            0
        )],
        [0, table(
            [0, -41.2],
            114.35,
            0.99,
            109.65,
            0
        )],
        [0, table(
            [0, -33.1],
            99.7,
            0.99,
            89.25,
            0
        )],
        [0, table(
            [0, -27.3],
            83.95,
            0.99,
            68.85,
            0
        )],
        [0, table(
            [0, -23.8],
            67.5,
            0.99,
            45.9,
            0
        )],
        [0, table(
            [0, -22.9],
            50.75,
            0.99,
            25.5,
            0
        )],
        [0, table(
            [0, -259.45],
            127.6,
            0.99,
            25.5,
            0
        )],
        [0, table(
            [0, -252.4],
            133.6,
            0.99,
            40.8,
            0
        )],
        [0, table(
            [0, -245],
            139.25,
            0.99,
            58.65,
            0
        )],
        [0, table(
            [0, -237.3],
            144.45,
            0.99,
            73.95,
            0
        )],
        [0, table(
            [0, -229.35],
            149.25,
            0.99,
            91.8,
            0
        )],
        [0, table(
            [0, -221.15],
            153.6,
            0.99,
            107.1,
            0
        )]
    )],
    [0, table(
        [0, table(
            [0, -283.75],
            [0, -8.5],
            0.65,
            25.5,
            0
        )],
        [0, table(
            [0, -280.05],
            2.7,
            0.65,
            40.8,
            0
        )],
        [0, table(
            [0, -275.65],
            13.65,
            0.65,
            58.65,
            0
        )],
        [0, table(
            [0, -270.5],
            24.25,
            0.65,
            73.95,
            0
        )],
        [0, table(
            [0, -264.6],
            34.5,
            0.65,
            91.8,
            0
        )],
        [0, table(
            [0, -258.05],
            44.3,
            0.65,
            107.1,
            0
        )],
        [0, table(
            [0, -250.75],
            53.6,
            0.65,
            124.95,
            0
        )],
        [0, table(
            [0, -242.8],
            62.3,
            0.65,
            140.25,
            0
        )],
        [0, table(
            [0, -234.2],
            70.4,
            0.65,
            155.55,
            0
        )],
        [0, table(
            [0, -225.05],
            77.85,
            0.65,
            173.4,
            0
        )],
        [0, table(
            [0, -215.35],
            84.6,
            0.65,
            188.7,
            0
        )],
        [0, table(
            [0, -205.2],
            90.6,
            0.65,
            206.55,
            0
        )],
        [0, table(
            [0, -194.6],
            95.75,
            0.65,
            221.85,
            0
        )],
        [0, table(
            [0, -183.65],
            100.15,
            0.65,
            239.7,
            0
        )],
        [0, table(
            [0, -172.35],
            103.55,
            0.65,
            255,
            0
        )],
        [0, table(
            [0, -156.95],
            106.9,
            0.65,
            234.6,
            0
        )],
        [0, table(
            [0, -141.35],
            108.5,
            0.65,
            214.2,
            0
        )],
        [0, table(
            [0, -125.65],
            108,
            0.65,
            191.25,
            0
        )],
        [0, table(
            [0, -110.1],
            105.35,
            0.65,
            170.85,
            0
        )],
        [0, table(
            [0, -95.1],
            100.6,
            0.65,
            150.45,
            0
        )],
        [0, table(
            [0, -80.85],
            93.9,
            0.65,
            130.05,
            0
        )],
        [0, table(
            [0, -67.7],
            85.35,
            0.65,
            109.65,
            0
        )],
        [0, table(
            [0, -55.8],
            75.05,
            0.65,
            89.25,
            0
        )],
        [0, table(
            [0, -45.45],
            63.15,
            0.65,
            68.85,
            0
        )],
        [0, table(
            [0, -36.85],
            50,
            0.65,
            45.9,
            0
        )],
        [0, table(
            [0, -30.4],
            35.65,
            0.65,
            25.5,
            0
        )]
    )],
    [0, table(
        [0, table(
            [0, -251.3],
            138.25,
            0.55,
            25.5,
            0
        )],
        [0, table(
            [0, -245.2],
            143.2,
            0.55,
            40.8,
            0
        )],
        [0, table(
            [0, -238.8],
            147.85,
            0.55,
            58.65,
            0
        )],
        [0, table(
            [0, -232.25],
            152.25,
            0.55,
            73.95,
            0
        )],
        [0, table(
            [0, -225.45],
            156.3,
            0.55,
            91.8,
            0
        )],
        [0, table(
            [0, -218.5],
            160,
            0.55,
            107.1,
            0
        )],
        [0, table(
            [0, -211.35],
            163.45,
            0.55,
            124.95,
            0
        )],
        [0, table(
            [0, -204.1],
            166.5,
            0.55,
            140.25,
            0
        )],
        [0, table(
            [0, -196.7],
            169.25,
            0.55,
            155.55,
            0
        )],
        [0, table(
            [0, -189.15],
            171.6,
            0.55,
            173.4,
            0
        )],
        [0, table(
            [0, -181.55],
            173.55,
            0.55,
            188.7,
            0
        )],
        [0, table(
            [0, -173.8],
            175.15,
            0.55,
            206.55,
            0
        )],
        [0, table(
            [0, -166],
            176.35,
            0.55,
            221.85,
            0
        )],
        [0, table(
            [0, -158.15],
            177.15,
            0.55,
            239.7,
            0
        )],
        [0, table(
            [0, -150.25],
            177.6,
            0.55,
            255,
            0
        )],
        [0, table(
            [0, -129.6],
            176.85,
            0.55,
            234.6,
            0
        )],
        [0, table(
            [0, -109.25],
            173.35,
            0.55,
            214.2,
            0
        )],
        [0, table(
            [0, -89.5],
            167.1,
            0.55,
            191.25,
            0
        )],
        [0, table(
            [0, -70.85],
            158.25,
            0.55,
            170.85,
            0
        )],
        [0, table(
            [0, -53.95],
            146.35,
            0.55,
            150.45,
            0
        )],
        [0, table(
            [0, -39.45],
            131.6,
            0.55,
            130.05,
            0
        )],
        [0, table(
            [0, -27.8],
            114.5,
            0.55,
            109.65,
            0
        )],
        [0, table(
            [0, -19.3],
            95.7,
            0.55,
            89.25,
            0
        )],
        [0, table(
            [0, -14.3],
            75.6,
            0.55,
            68.85,
            0
        )],
        [0, table(
            [0, -13.05],
            54.95,
            0.55,
            45.9,
            0
        )],
        [0, table(
            [0, -15.8],
            34.5,
            0.55,
            25.5,
            0
        )]
    )],
    [0, table(
        [0, table(
            [0, -221.7],
            106.85,
            0.94,
            173.4,
            0
        )],
        [0, table(
            [0, -212.6],
            111.8,
            0.94,
            188.7,
            0
        )],
        [0, table(
            [0, -203.25],
            116.15,
            0.94,
            206.55,
            0
        )],
        [0, table(
            [0, -193.65],
            119.85,
            0.94,
            221.85,
            0
        )],
        [0, table(
            [0, -183.85],
            122.9,
            0.94,
            239.7,
            0
        )],
        [0, table(
            [0, -173.8],
            125.3,
            0.94,
            255,
            0
        )],
        [0, table(
            [0, -158.4],
            127.6,
            0.94,
            234.6,
            0
        )],
        [0, table(
            [0, -142.8],
            128.35,
            0.94,
            214.2,
            0
        )],
        [0, table(
            [0, -127.3],
            127.3,
            0.94,
            191.25,
            0
        )],
        [0, table(
            [0, -112.05],
            124.2,
            0.94,
            170.85,
            0
        )],
        [0, table(
            [0, -97.3],
            119.05,
            0.94,
            150.45,
            0
        )],
        [0, table(
            [0, -83.4],
            111.9,
            0.94,
            130.05,
            0
        )],
        [0, table(
            [0, -70.65],
            103.1,
            0.94,
            109.65,
            0
        )],
        [0, table(
            [0, -59.1],
            92.6,
            0.94,
            89.25,
            0
        )],
        [0, table(
            [0, -49.15],
            80.6,
            0.94,
            68.85,
            0
        )],
        [0, table(
            [0, -40.95],
            67.3,
            0.94,
            45.9,
            0
        )],
        [0, table(
            [0, -34.55],
            53.1,
            0.94,
            25.5,
            0
        )],
        [0, table(
            [0, -284.15],
            39.95,
            0.94,
            25.5,
            0
        )],
        [0, table(
            [0, -279.2],
            48.95,
            0.94,
            40.8,
            0
        )],
        [0, table(
            [0, -273.7],
            57.7,
            0.94,
            58.65,
            0
        )],
        [0, table(
            [0, -267.65],
            66.05,
            0.94,
            73.95,
            0
        )],
        [0, table(
            [0, -261.15],
            74.05,
            0.94,
            91.8,
            0
        )],
        [0, table(
            [0, -254.15],
            81.65,
            0.94,
            107.1,
            0
        )],
        [0, table(
            [0, -246.65],
            88.7,
            0.94,
            124.95,
            0
        )],
        [0, table(
            [0, -238.75],
            95.3,
            0.94,
            140.25,
            0
        )],
        [0, table(
            [0, -230.4],
            101.35,
            0.94,
            155.55,
            0
        )]
    )],
    [0, table(
        [0, table(
            [0, -140.4],
            136.85,
            0.9,
            255,
            0
        )],
        [0, table(
            [0, -126.55],
            135.7,
            0.9,
            234.6,
            0
        )],
        [0, table(
            [0, -112.95],
            133.05,
            0.9,
            214.2,
            0
        )],
        [0, table(
            [0, -99.75],
            128.75,
            0.9,
            191.25,
            0
        )],
        [0, table(
            [0, -87.1],
            122.85,
            0.9,
            170.85,
            0
        )],
        [0, table(
            [0, -75.3],
            115.45,
            0.9,
            150.45,
            0
        )],
        [0, table(
            [0, -64.45],
            106.8,
            0.9,
            130.05,
            0
        )],
        [0, table(
            [0, -54.75],
            96.85,
            0.9,
            109.65,
            0
        )],
        [0, table(
            [0, -46.3],
            85.8,
            0.9,
            89.25,
            0
        )],
        [0, table(
            [0, -39.3],
            73.75,
            0.9,
            68.85,
            0
        )],
        [0, table(
            [0, -33.75],
            61,
            0.9,
            45.9,
            0
        )],
        [0, table(
            [0, -29.9],
            47.65,
            0.9,
            25.5,
            0
        )],
        [0, table(
            [0, -265.5],
            80.7,
            0.9,
            25.5,
            0
        )],
        [0, table(
            [0, -258.7],
            88.2,
            0.9,
            40.8,
            0
        )],
        [0, table(
            [0, -251.5],
            95.35,
            0.9,
            58.65,
            0
        )],
        [0, table(
            [0, -243.8],
            101.95,
            0.9,
            73.95,
            0
        )],
        [0, table(
            [0, -235.75],
            108.05,
            0.9,
            91.8,
            0
        )],
        [0, table(
            [0, -227.3],
            113.65,
            0.9,
            107.1,
            0
        )],
        [0, table(
            [0, -218.5],
            118.7,
            0.9,
            124.95,
            0
        )],
        [0, table(
            [0, -209.35],
            123.15,
            0.9,
            140.25,
            0
        )],
        [0, table(
            [0, -200],
            127.05,
            0.9,
            155.55,
            0
        )],
        [0, table(
            [0, -190.4],
            130.3,
            0.9,
            173.4,
            0
        )],
        [0, table(
            [0, -180.65],
            132.95,
            0.9,
            188.7,
            0
        )],
        [0, table(
            [0, -170.7],
            134.95,
            0.9,
            206.55,
            0
        )],
        [0, table(
            [0, -160.65],
            136.25,
            0.9,
            221.85,
            0
        )],
        [0, table(
            [0, -150.55],
            136.9,
            0.9,
            239.7,
            0
        )]
    )],
    [0, table(
        [0, table(
            [0, -91.2],
            139.45,
            0.67,
            170.85,
            0
        )],
        [0, table(
            [0, -77.4],
            132.2,
            0.67,
            150.45,
            0
        )],
        [0, table(
            [0, -64.65],
            123.1,
            0.67,
            130.05,
            0
        )],
        [0, table(
            [0, -53.3],
            112.45,
            0.67,
            109.65,
            0
        )],
        [0, table(
            [0, -43.45],
            100.4,
            0.67,
            89.25,
            0
        )],
        [0, table(
            [0, -35.3],
            87.1,
            0.67,
            68.85,
            0
        )],
        [0, table(
            [0, -29.05],
            72.8,
            0.67,
            45.9,
            0
        )],
        [0, table(
            [0, -25.2],
            57.7,
            0.67,
            25.5,
            0
        )],
        [0, table(
            [0, -274.45],
            84.8,
            0.67,
            25.5,
            0
        )],
        [0, table(
            [0, -268],
            92.75,
            0.67,
            40.8,
            0
        )],
        [0, table(
            [0, -261.15],
            100.3,
            0.67,
            58.65,
            0
        )],
        [0, table(
            [0, -253.85],
            107.5,
            0.67,
            73.95,
            0
        )],
        [0, table(
            [0, -246.1],
            114.2,
            0.67,
            91.8,
            0
        )],
        [0, table(
            [0, -237.95],
            120.45,
            0.67,
            107.1,
            0
        )],
        [0, table(
            [0, -229.5],
            126.15,
            0.67,
            124.95,
            0
        )],
        [0, table(
            [0, -220.65],
            131.3,
            0.67,
            140.25,
            0
        )],
        [0, table(
            [0, -211.5],
            135.85,
            0.67,
            155.55,
            0
        )],
        [0, table(
            [0, -202.05],
            139.8,
            0.67,
            173.4,
            0
        )],
        [0, table(
            [0, -192.35],
            143.15,
            0.67,
            188.7,
            0
        )],
        [0, table(
            [0, -182.5],
            145.85,
            0.67,
            206.55,
            0
        )],
        [0, table(
            [0, -172.5],
            147.95,
            0.67,
            221.85,
            0
        )],
        [0, table(
            [0, -162.35],
            149.35,
            0.67,
            239.7,
            0
        )],
        [0, table(
            [0, -152.15],
            150.1,
            0.67,
            255,
            0
        )],
        [0, table(
            [0, -136.55],
            149.9,
            0.67,
            234.6,
            0
        )],
        [0, table(
            [0, -121.05],
            148.1,
            0.67,
            214.2,
            0
        )],
        [0, table(
            [0, -105.85],
            144.7,
            0.67,
            191.25,
            0
        )]
    )]
)
CommonEffectConfig.bomb_stars = table(
    [0, table(
        [0, table(
            40.1,
            139.8,
            0.79,
            255,
            90.14
        )],
        [0, table(
            40.2,
            143.9,
            0.76,
            234.6,
            90.03
        )],
        [0, table(
            40.3,
            147.95,
            0.72,
            214.2,
            90.03
        )],
        [0, table(
            40.4,
            151.95,
            0.69,
            193.8,
            90.03
        )],
        [0, table(
            40.55,
            156.05,
            0.66,
            173.4,
            90.04
        )],
        [0, table(
            40.7,
            160.1,
            0.63,
            155.55,
            90.04
        )],
        [0, table(
            40.75,
            164.2,
            0.59,
            135.15,
            90.03
        )],
        [0, table(
            40.85,
            168.25,
            0.56,
            114.75,
            90.04
        )],
        [0, table(
            41.05,
            172.25,
            0.53,
            94.35,
            90.04
        )],
        [0, table(
            41.2,
            176.3,
            0.49,
            73.95,
            90.04
        )],
        [0, table(
            41.25,
            180.4,
            0.46,
            53.55,
            90.03
        )],
        [0, table(
            41.4,
            184.4,
            0.43,
            33.15,
            90.03
        )],
        [0, table(
            41.55,
            188.5,
            0.4,
            12.75,
            90.14
        )]
    )],
    [0, table(
        [0, table(
            [0, -118.4],
            11.35,
            0.69,
            255,
            90.14
        )],
        [0, table(
            [0, -123.6],
            11.25,
            0.66,
            234.6,
            90.03
        )],
        [0, table(
            [0, -128.75],
            11.1,
            0.63,
            214.2,
            90.03
        )],
        [0, table(
            [0, -133.8],
            10.95,
            0.6,
            193.8,
            90.03
        )],
        [0, table(
            [0, -139],
            10.8,
            0.57,
            173.4,
            90.03
        )],
        [0, table(
            [0, -144.15],
            10.6,
            0.54,
            155.55,
            90.03
        )],
        [0, table(
            [0, -149.25],
            10.5,
            0.51,
            135.15,
            90.03
        )],
        [0, table(
            [0, -154.4],
            10.35,
            0.49,
            114.75,
            90.03
        )],
        [0, table(
            [0, -159.55],
            10.2,
            0.46,
            94.35,
            90.03
        )],
        [0, table(
            [0, -164.65],
            10.05,
            0.43,
            73.95,
            90.03
        )],
        [0, table(
            [0, -169.8],
            9.9,
            0.4,
            53.55,
            90.03
        )],
        [0, table(
            [0, -174.95],
            9.7,
            0.37,
            33.15,
            90.03
        )],
        [0, table(
            [0, -180.1],
            9.55,
            0.34,
            12.75,
            90.14
        )]
    )],
    [0, table(
        [0, table(
            [0, -57.15],
            122.7,
            0.69,
            255,
            90.14
        )],
        [0, table(
            [0, -59.1],
            124.9,
            0.66,
            234.6,
            90.03
        )],
        [0, table(
            [0, -61],
            127.1,
            0.63,
            214.2,
            90.03
        )],
        [0, table(
            [0, -62.95],
            129.25,
            0.6,
            193.8,
            90.03
        )],
        [0, table(
            [0, -64.8],
            131.4,
            0.57,
            173.4,
            90.03
        )],
        [0, table(
            [0, -66.7],
            133.6,
            0.54,
            155.55,
            90.03
        )],
        [0, table(
            [0, -68.6],
            135.7,
            0.51,
            135.15,
            90.03
        )],
        [0, table(
            [0, -70.55],
            137.9,
            0.49,
            114.75,
            90.03
        )],
        [0, table(
            [0, -72.5],
            140.1,
            0.46,
            94.35,
            90.03
        )],
        [0, table(
            [0, -74.4],
            142.25,
            0.43,
            73.95,
            90.03
        )],
        [0, table(
            [0, -76.25],
            144.4,
            0.4,
            53.55,
            90.03
        )],
        [0, table(
            [0, -78.15],
            146.6,
            0.37,
            33.15,
            90.03
        )],
        [0, table(
            [0, -80.05],
            148.75,
            0.34,
            12.75,
            90.14
        )]
    )],
    [0, table(
        [0, table(
            145.55,
            23.15,
            0.79,
            255,
            90.14
        )],
        [0, table(
            149.85,
            23.15,
            0.76,
            234.6,
            90.03
        )],
        [0, table(
            154.2,
            23.15,
            0.72,
            214.2,
            90.03
        )],
        [0, table(
            158.55,
            23.2,
            0.69,
            193.8,
            90.03
        )],
        [0, table(
            162.85,
            23.1,
            0.66,
            173.4,
            90.04
        )],
        [0, table(
            167.15,
            23.1,
            0.63,
            155.55,
            90.04
        )],
        [0, table(
            171.5,
            23.05,
            0.59,
            135.15,
            90.03
        )],
        [0, table(
            175.8,
            23.1,
            0.56,
            114.75,
            90.04
        )],
        [0, table(
            180.2,
            23,
            0.53,
            94.35,
            90.04
        )],
        [0, table(
            184.55,
            23,
            0.49,
            73.95,
            90.04
        )],
        [0, table(
            188.85,
            23,
            0.46,
            53.55,
            90.03
        )],
        [0, table(
            193.25,
            23,
            0.43,
            33.15,
            90.03
        )],
        [0, table(
            197.6,
            23,
            0.4,
            12.75,
            90.14
        )]
    )],
    [0, table(
        [0, table(
            86,
            [0, -91.15],
            0.69,
            255,
            90.14
        )],
        [0, table(
            89.5,
            [0, -96.45],
            0.66,
            234.6,
            90.03
        )],
        [0, table(
            93,
            [0, -101.65],
            0.63,
            214.2,
            90.03
        )],
        [0, table(
            96.4,
            [0, -106.95],
            0.6,
            193.8,
            90.03
        )],
        [0, table(
            99.95,
            [0, -112.2],
            0.57,
            173.4,
            90.03
        )],
        [0, table(
            103.45,
            [0, -117.55],
            0.54,
            155.55,
            90.03
        )],
        [0, table(
            107,
            [0, -122.75],
            0.51,
            135.15,
            90.03
        )],
        [0, table(
            110.45,
            [0, -128.05],
            0.49,
            114.75,
            90.03
        )],
        [0, table(
            114,
            [0, -133.35],
            0.46,
            94.35,
            90.03
        )],
        [0, table(
            117.5,
            [0, -138.55],
            0.43,
            73.95,
            90.03
        )],
        [0, table(
            121,
            [0, -143.9],
            0.4,
            53.55,
            90.03
        )],
        [0, table(
            124.5,
            [0, -149.15],
            0.37,
            33.15,
            90.03
        )],
        [0, table(
            128,
            [0, -154.45],
            0.34,
            12.75,
            90.14
        )]
    )],
    [0, table(
        [0, table(
            15.35,
            [0, -117.05],
            0.79,
            255,
            90.14
        )],
        [0, table(
            14.35,
            [0, -122.15],
            0.76,
            234.6,
            90.03
        )],
        [0, table(
            13.35,
            [0, -127.3],
            0.72,
            214.2,
            90.03
        )],
        [0, table(
            12.4,
            [0, -132.5],
            0.69,
            193.8,
            90.03
        )],
        [0, table(
            11.35,
            [0, -137.6],
            0.66,
            173.4,
            90.04
        )],
        [0, table(
            10.4,
            [0, -142.75],
            0.63,
            155.55,
            90.04
        )],
        [0, table(
            9.4,
            [0, -147.95],
            0.59,
            135.15,
            90.03
        )],
        [0, table(
            8.35,
            [0, -153.05],
            0.56,
            114.75,
            90.04
        )],
        [0, table(
            7.35,
            [0, -158.15],
            0.53,
            94.35,
            90.04
        )],
        [0, table(
            6.35,
            [0, -163.25],
            0.49,
            73.95,
            90.04
        )],
        [0, table(
            5.35,
            [0, -168.4],
            0.46,
            53.55,
            90.03
        )],
        [0, table(
            4.3,
            [0, -173.55],
            0.43,
            33.15,
            90.03
        )],
        [0, table(
            3.35,
            [0, -178.7],
            0.4,
            12.75,
            90.14
        )]
    )],
    [0, table(
        [0, table(
            [0, -112.85],
            [0, -34.45],
            0.79,
            255,
            60.14
        )],
        [0, table(
            [0, -116.9],
            [0, -37.65],
            0.76,
            234.6,
            60.18
        )],
        [0, table(
            [0, -120.9],
            [0, -40.95],
            0.72,
            214.2,
            60.18
        )],
        [0, table(
            [0, -124.9],
            [0, -44.1],
            0.69,
            193.8,
            60.18
        )],
        [0, table(
            [0, -128.95],
            [0, -47.35],
            0.66,
            173.4,
            60.18
        )],
        [0, table(
            [0, -132.95],
            [0, -50.6],
            0.62,
            155.55,
            60.18
        )],
        [0, table(
            [0, -136.95],
            [0, -53.85],
            0.59,
            135.15,
            60.18
        )],
        [0, table(
            [0, -141],
            [0, -57.05],
            0.56,
            114.75,
            60.18
        )],
        [0, table(
            [0, -145],
            [0, -60.3],
            0.53,
            94.35,
            60.18
        )],
        [0, table(
            [0, -149],
            [0, -63.45],
            0.49,
            73.95,
            60.18
        )],
        [0, table(
            [0, -153],
            [0, -66.7],
            0.46,
            53.55,
            60.18
        )],
        [0, table(
            [0, -157],
            [0, -69.95],
            0.43,
            33.15,
            60.17
        )],
        [0, table(
            [0, -161.05],
            [0, -73.2],
            0.4,
            12.75,
            60.14
        )]
    )],
    [0, table(
        [0, table(
            [0, -109.3],
            84.55,
            0.79,
            255,
            60.14
        )],
        [0, table(
            [0, -112.2],
            86.1,
            0.76,
            234.6,
            60.18
        )],
        [0, table(
            [0, -115],
            87.6,
            0.72,
            214.2,
            60.18
        )],
        [0, table(
            [0, -117.95],
            89.25,
            0.69,
            193.8,
            60.18
        )],
        [0, table(
            [0, -120.85],
            90.7,
            0.66,
            173.4,
            60.18
        )],
        [0, table(
            [0, -123.8],
            92.25,
            0.62,
            155.55,
            60.18
        )],
        [0, table(
            [0, -126.65],
            93.8,
            0.59,
            135.15,
            60.18
        )],
        [0, table(
            [0, -129.55],
            95.3,
            0.56,
            114.75,
            60.18
        )],
        [0, table(
            [0, -132.45],
            96.85,
            0.53,
            94.35,
            60.18
        )],
        [0, table(
            [0, -135.3],
            98.45,
            0.49,
            73.95,
            60.18
        )],
        [0, table(
            [0, -138.2],
            100,
            0.46,
            53.55,
            60.18
        )],
        [0, table(
            [0, -141.1],
            101.55,
            0.43,
            33.15,
            60.17
        )],
        [0, table(
            [0, -144],
            103.1,
            0.4,
            12.75,
            60.14
        )]
    )],
    [0, table(
        [0, table(
            [0, -7.45],
            151.45,
            0.87,
            255,
            60.14
        )],
        [0, table(
            [0, -7.65],
            156.35,
            0.84,
            234.6,
            60.18
        )],
        [0, table(
            [0, -7.85],
            161.15,
            0.8,
            214.2,
            60.18
        )],
        [0, table(
            [0, -8],
            166.05,
            0.76,
            193.8,
            60.18
        )],
        [0, table(
            [0, -8.15],
            170.85,
            0.73,
            173.4,
            60.18
        )],
        [0, table(
            [0, -8.35],
            175.75,
            0.69,
            155.55,
            60.18
        )],
        [0, table(
            [0, -8.5],
            180.55,
            0.65,
            135.15,
            60.18
        )],
        [0, table(
            [0, -8.7],
            185.5,
            0.62,
            114.75,
            60.18
        )],
        [0, table(
            [0, -8.8],
            190.35,
            0.58,
            94.35,
            60.18
        )],
        [0, table(
            [0, -9],
            195.2,
            0.55,
            73.95,
            60.18
        )],
        [0, table(
            [0, -9.2],
            200.05,
            0.51,
            53.55,
            60.18
        )],
        [0, table(
            [0, -9.35],
            204.85,
            0.47,
            33.15,
            60.18
        )],
        [0, table(
            [0, -9.5],
            209.75,
            0.44,
            12.75,
            60.14
        )]
    )],
    [0, table(
        [0, table(
            103.2,
            118.1,
            1,
            255,
            60.14
        )],
        [0, table(
            106.55,
            119.8,
            0.96,
            234.6,
            60.18
        )],
        [0, table(
            109.9,
            121.55,
            0.91,
            214.2,
            60.18
        )],
        [0, table(
            113.2,
            123.4,
            0.87,
            193.8,
            60.18
        )],
        [0, table(
            116.5,
            125.15,
            0.83,
            173.4,
            60.18
        )],
        [0, table(
            119.8,
            126.95,
            0.79,
            155.55,
            60.18
        )],
        [0, table(
            123.15,
            128.65,
            0.75,
            135.15,
            60.18
        )],
        [0, table(
            126.45,
            130.35,
            0.71,
            114.75,
            60.18
        )],
        [0, table(
            129.8,
            132.1,
            0.66,
            94.35,
            60.18
        )],
        [0, table(
            133.05,
            133.9,
            0.62,
            73.95,
            60.17
        )],
        [0, table(
            136.4,
            135.65,
            0.58,
            53.55,
            60.18
        )],
        [0, table(
            139.8,
            137.35,
            0.54,
            33.15,
            60.18
        )],
        [0, table(
            143.05,
            139.1,
            0.5,
            12.75,
            60.14
        )]
    )]
)
CommonEffectConfig.lines_offset = table(
    [0, table(
        [0, table(
            [0, -259.65],
            [0, -155.25],
            1,
            51,
            [0, -43.26]
        )],
        [0, table(
            [0, -262.25],
            [0, -140.55],
            1.03,
            102,
            [0, -38.93]
        )],
        [0, table(
            [0, -263.75],
            [0, -125.75],
            1.05,
            153,
            [0, -34.65]
        )],
        [0, table(
            [0, -264.15],
            [0, -110.85],
            1.08,
            204,
            [0, -30.18]
        )],
        [0, table(
            [0, -263.45],
            [0, -95.95],
            1.1,
            255,
            [0, -25.89]
        )],
        [0, table(
            [0, -261.6],
            [0, -81.2],
            1.13,
            255,
            [0, -21.41]
        )],
        [0, table(
            [0, -258.65],
            [0, -66.5],
            1.16,
            255,
            [0, -17.12]
        )],
        [0, table(
            [0, -254.75],
            [0, -52.1],
            1.18,
            255,
            [0, -12.64]
        )],
        [0, table(
            [0, -249.8],
            [0, -38.05],
            1.21,
            255,
            [0, -8.34]
        )],
        [0, table(
            [0, -244],
            [0, -24.4],
            1.23,
            255,
            [0, -3.86]
        )],
        [0, table(
            [0, -237.2],
            [0, -11.15],
            1.26,
            255,
            0.43
        )],
        [0, table(
            [0, -229.35],
            1.55,
            1.29,
            255,
            4.92
        )],
        [0, table(
            [0, -220.6],
            13.65,
            1.31,
            255,
            9.21
        )],
        [0, table(
            [0, -210.95],
            25.1,
            1.34,
            255,
            13.69
        )],
        [0, table(
            [0, -200.8],
            35.65,
            1.37,
            255,
            17.98
        )],
        [0, table(
            [0, -182.1],
            51.45,
            1.33,
            255,
            25.75
        )],
        [0, table(
            [0, -161.4],
            64.75,
            1.29,
            255,
            33.51
        )],
        [0, table(
            [0, -139],
            75.25,
            1.26,
            255,
            41.27
        )],
        [0, table(
            [0, -115.55],
            82.55,
            1.22,
            255,
            48.83
        )],
        [0, table(
            [0, -91.2],
            86.55,
            1.18,
            255,
            56.58
        )],
        [0, table(
            [0, -66.65],
            86.65,
            1.15,
            255,
            64.34
        )],
        [0, table(
            [0, -42.4],
            82.8,
            1.11,
            204,
            72.11
        )],
        [0, table(
            [0, -18.9],
            75.15,
            1.07,
            153,
            79.88
        )],
        [0, table(
            3.15,
            64.55,
            1.03,
            102,
            87.65
        )],
        [0, table(
            23.55,
            50.8,
            1,
            51,
            95.36
        )],
        [0, table(
            23.55,
            50.8,
            1,
            0,
            95.36
        )]
    )],
    [0, table(
        [0, table(
            [0, -258.65],
            [0, -66.5],
            1.16,
            255,
            [0, -17.12]
        )],
        [0, table(
            [0, -254.75],
            [0, -52.1],
            1.18,
            255,
            [0, -12.64]
        )],
        [0, table(
            [0, -249.8],
            [0, -38.05],
            1.21,
            255,
            [0, -8.34]
        )],
        [0, table(
            [0, -244],
            [0, -24.4],
            1.23,
            255,
            [0, -3.86]
        )],
        [0, table(
            [0, -237.2],
            [0, -11.15],
            1.26,
            255,
            0.43
        )],
        [0, table(
            [0, -229.35],
            1.55,
            1.29,
            255,
            4.92
        )],
        [0, table(
            [0, -220.6],
            13.65,
            1.31,
            255,
            9.21
        )],
        [0, table(
            [0, -210.95],
            25.1,
            1.34,
            255,
            13.69
        )],
        [0, table(
            [0, -200.8],
            35.65,
            1.37,
            255,
            17.98
        )],
        [0, table(
            [0, -182.1],
            51.45,
            1.33,
            255,
            25.75
        )],
        [0, table(
            [0, -161.4],
            64.75,
            1.29,
            255,
            33.51
        )],
        [0, table(
            [0, -139],
            75.25,
            1.26,
            255,
            41.27
        )],
        [0, table(
            [0, -115.55],
            82.55,
            1.22,
            255,
            48.83
        )],
        [0, table(
            [0, -91.2],
            86.55,
            1.18,
            255,
            56.58
        )],
        [0, table(
            [0, -66.65],
            86.65,
            1.15,
            255,
            64.34
        )],
        [0, table(
            [0, -42.4],
            82.8,
            1.11,
            204,
            72.11
        )],
        [0, table(
            [0, -18.9],
            75.15,
            1.07,
            153,
            79.88
        )],
        [0, table(
            3.15,
            64.55,
            1.03,
            102,
            87.65
        )],
        [0, table(
            23.55,
            50.8,
            1,
            51,
            95.36
        )],
        [0, table(
            23.55,
            50.8,
            1,
            0,
            95.36
        )],
        [0, table(
            [0, -259.65],
            [0, -155.25],
            1,
            51,
            [0, -43.26]
        )],
        [0, table(
            [0, -262.25],
            [0, -140.55],
            1.03,
            102,
            [0, -38.93]
        )],
        [0, table(
            [0, -263.75],
            [0, -125.75],
            1.05,
            153,
            [0, -34.65]
        )],
        [0, table(
            [0, -264.15],
            [0, -110.85],
            1.08,
            204,
            [0, -30.18]
        )],
        [0, table(
            [0, -263.45],
            [0, -95.95],
            1.1,
            255,
            [0, -25.89]
        )],
        [0, table(
            [0, -261.6],
            [0, -81.2],
            1.13,
            255,
            [0, -21.41]
        )]
    )],
    [0, table(
        [0, table(
            [0, -200.8],
            35.65,
            1.37,
            255,
            17.98
        )],
        [0, table(
            [0, -182.1],
            51.45,
            1.33,
            255,
            25.75
        )],
        [0, table(
            [0, -161.4],
            64.75,
            1.29,
            255,
            33.51
        )],
        [0, table(
            [0, -139],
            75.25,
            1.26,
            255,
            41.27
        )],
        [0, table(
            [0, -115.55],
            82.55,
            1.22,
            255,
            48.83
        )],
        [0, table(
            [0, -91.2],
            86.55,
            1.18,
            255,
            56.58
        )],
        [0, table(
            [0, -66.65],
            86.65,
            1.15,
            255,
            64.34
        )],
        [0, table(
            [0, -42.4],
            82.8,
            1.11,
            204,
            72.11
        )],
        [0, table(
            [0, -18.9],
            75.15,
            1.07,
            153,
            79.88
        )],
        [0, table(
            3.15,
            64.55,
            1.03,
            102,
            87.65
        )],
        [0, table(
            23.55,
            50.8,
            1,
            51,
            95.36
        )],
        [0, table(
            23.55,
            50.8,
            1,
            0,
            95.36
        )],
        [0, table(
            [0, -259.65],
            [0, -155.25],
            1,
            51,
            [0, -43.26]
        )],
        [0, table(
            [0, -262.25],
            [0, -140.55],
            1.03,
            102,
            [0, -38.93]
        )],
        [0, table(
            [0, -263.75],
            [0, -125.75],
            1.05,
            153,
            [0, -34.65]
        )],
        [0, table(
            [0, -264.15],
            [0, -110.85],
            1.08,
            204,
            [0, -30.18]
        )],
        [0, table(
            [0, -263.45],
            [0, -95.95],
            1.1,
            255,
            [0, -25.89]
        )],
        [0, table(
            [0, -261.6],
            [0, -81.2],
            1.13,
            255,
            [0, -21.41]
        )],
        [0, table(
            [0, -258.65],
            [0, -66.5],
            1.16,
            255,
            [0, -17.12]
        )],
        [0, table(
            [0, -254.75],
            [0, -52.1],
            1.18,
            255,
            [0, -12.64]
        )],
        [0, table(
            [0, -249.8],
            [0, -38.05],
            1.21,
            255,
            [0, -8.34]
        )],
        [0, table(
            [0, -244],
            [0, -24.4],
            1.23,
            255,
            [0, -3.86]
        )],
        [0, table(
            [0, -237.2],
            [0, -11.15],
            1.26,
            255,
            0.43
        )],
        [0, table(
            [0, -229.35],
            1.55,
            1.29,
            255,
            4.92
        )],
        [0, table(
            [0, -220.6],
            13.65,
            1.31,
            255,
            9.21
        )],
        [0, table(
            [0, -210.95],
            25.1,
            1.34,
            255,
            13.69
        )]
    )],
    [0, table(
        [0, table(
            [0, -91.2],
            86.55,
            1.18,
            255,
            56.58
        )],
        [0, table(
            [0, -66.65],
            86.65,
            1.15,
            255,
            64.34
        )],
        [0, table(
            [0, -42.4],
            82.8,
            1.11,
            204,
            72.11
        )],
        [0, table(
            [0, -18.9],
            75.15,
            1.07,
            153,
            79.88
        )],
        [0, table(
            3.15,
            64.55,
            1.03,
            102,
            87.65
        )],
        [0, table(
            23.55,
            50.8,
            1,
            51,
            95.36
        )],
        [0, table(
            23.55,
            50.8,
            1,
            0,
            95.36
        )],
        [0, table(
            [0, -259.65],
            [0, -155.25],
            1,
            51,
            [0, -43.26]
        )],
        [0, table(
            [0, -262.25],
            [0, -140.55],
            1.03,
            102,
            [0, -38.93]
        )],
        [0, table(
            [0, -263.75],
            [0, -125.75],
            1.05,
            153,
            [0, -34.65]
        )],
        [0, table(
            [0, -264.15],
            [0, -110.85],
            1.08,
            204,
            [0, -30.18]
        )],
        [0, table(
            [0, -263.45],
            [0, -95.95],
            1.1,
            255,
            [0, -25.89]
        )],
        [0, table(
            [0, -261.6],
            [0, -81.2],
            1.13,
            255,
            [0, -21.41]
        )],
        [0, table(
            [0, -258.65],
            [0, -66.5],
            1.16,
            255,
            [0, -17.12]
        )],
        [0, table(
            [0, -254.75],
            [0, -52.1],
            1.18,
            255,
            [0, -12.64]
        )],
        [0, table(
            [0, -249.8],
            [0, -38.05],
            1.21,
            255,
            [0, -8.34]
        )],
        [0, table(
            [0, -244],
            [0, -24.4],
            1.23,
            255,
            [0, -3.86]
        )],
        [0, table(
            [0, -237.2],
            [0, -11.15],
            1.26,
            255,
            0.43
        )],
        [0, table(
            [0, -229.35],
            1.55,
            1.29,
            255,
            4.92
        )],
        [0, table(
            [0, -220.6],
            13.65,
            1.31,
            255,
            9.21
        )],
        [0, table(
            [0, -210.95],
            25.1,
            1.34,
            255,
            13.69
        )],
        [0, table(
            [0, -200.8],
            35.65,
            1.37,
            255,
            17.98
        )],
        [0, table(
            [0, -182.1],
            51.45,
            1.33,
            255,
            25.75
        )],
        [0, table(
            [0, -161.4],
            64.75,
            1.29,
            255,
            33.51
        )],
        [0, table(
            [0, -139],
            75.25,
            1.26,
            255,
            41.27
        )],
        [0, table(
            [0, -115.55],
            82.55,
            1.22,
            255,
            48.83
        )]
    )]
)
